import { render } from "./CheckMarkAnimation.vue?vue&type=template&id=5065d774&scoped=true&ts=true"
import script from "./CheckMarkAnimation.vue?vue&type=script&lang=ts"
export * from "./CheckMarkAnimation.vue?vue&type=script&lang=ts"

import "./CheckMarkAnimation.vue?vue&type=style&index=0&id=5065d774&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5065d774"]])

export default __exports__